// extracted by mini-css-extract-plugin
export default {"color-grey-5":"#DADADA","colorGrey5":"#DADADA","color-subtle-grey":"#f5f4f2","colorSubtleGrey":"#f5f4f2","overlay":"FgpIg","divider":"oR3BO","disclaimer":"aJKPb"};